<div #nextBackBtnContainer class="row columns align-middle align-spaced next-back-btn-container" [ngClass]="(isBackground)? 'is-background' : ''">
  <button class="mc-btn-disable" (click)="onCancelEvent.emit(true)"
    style="border: 1px white solid; border-radius: 5px; width: 220px; margin-right: 25px;">
    <span style="color: #4A5861;">BACK</span>
  </button>
  <button class="mc-btn" (click)="onNextEvent.emit(true)"
    [disabled]="isDisableNextBtn"
    style="border: 1px white solid; border-radius: 5px; width: 220px;">
    <span style="color: #4A5861;">NEXT</span>
  </button>
</div>